module.exports = __webpack_public_path__ + "static/bg-welcome-78349c1277dc44448394c4c975808d4a.png";